import { GameCssStyles } from '../GameCssStyles'
import { Box } from '@mui/material'
import StandardAboutGame from '../CommonLayout/StandardAboutGame'
import FantasyManiaPool from './FantasyManiaPool'
import SponseredBy from '../CommonLayout/SponseredBy'
import StandardForkContestRulesV2 from '../CommonLayout/StandardForkContestRulesV2'

const FantasyLeagueGame = ({ formGameData, showsList, setFormGameData, handleChange }) => {
    return (
        <Box sx={GameCssStyles.containerStyleColumnWithoutBorder_sx}>
            <StandardAboutGame formGameData={formGameData} handleChange={handleChange} />
            {/* <PredictionAnchor formGameData={formGameData} showsList={showsList} handleChange={handleChange} /> */}
            {/* <FantasyQuestionEditor formGameData={formGameData} setFormGameData={setFormGameData} handleChange={handleChange} /> */}
            <SponseredBy formGameData={formGameData}  setFormGameData={setFormGameData} handleChange={handleChange} />
            <FantasyManiaPool formGameData={formGameData} setFormGameData={setFormGameData} handleChange={handleChange} />
            {/* <StandardForkContestRulesV2 formGameData={formGameData} setFormGameData={setFormGameData} handleChange={handleChange} /> */}
        </Box>
    )
}

export default FantasyLeagueGame
